import {useEffect, useRef} from 'react'
import { useFormContext, useWatch } from 'react-hook-form'

export const PatientDrugsInpLogic = (sectionName, drugName="", noteName="" ) => {
    const {setValue, control} = useFormContext()
    // The section is "active" whenever its toggle value in the form is truthy.
    // Deriving it from the live form value (instead of a mount-time snapshot)
    // means the section enables itself when the form gets prefilled.
    const toggle = useWatch({control: control, name: sectionName})
    const active = !!toggle
    const wasOn = useRef(active)

    // Clear the section's own fields ONLY when the user switches the section
    // off (on -> off). Never on mount / during prefill, and never touch the
    // rest of the form (no whole-form reset).
    useEffect (() => {
        if (wasOn.current && !toggle) {
            clearFormValues()
        }
        wasOn.current = !!toggle
    }, [toggle])

    const clearFormValues = () => {
        if (drugName.length != 0) {
            setValue(drugName, [{label: "Vyhledejte...", value: ""}])
        }
        if (noteName.length != 0)  {
            setValue(noteName, "")
        }
    }

    const toggleSection = () => {}

    return {state: {active}, toggleSection}
}
